import React from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  Container,
} from '@mui/material';

interface AuthLoaderProps {
  message?: string;
}

const AuthLoader: React.FC<AuthLoaderProps> = ({ 
  message = 'Initializing application...' 
}) => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 3,
        }}
      >
        {/* App Branding */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
            Creative Studio
          </Typography>
          <Typography variant="body2" color="text.secondary">
            The Creative Assistant
          </Typography>
        </Box>

        {/* Loading Indicator */}
        <CircularProgress size={60} thickness={4} />

        {/* Loading Message */}
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ 
            fontSize: '1.1rem',
            fontWeight: 500,
          }}
        >
          {message}
        </Typography>

        {/* Additional Info */}
        <Typography 
          variant="caption" 
          color="text.secondary"
          sx={{ 
            maxWidth: 400,
            lineHeight: 1.5,
            mt: 1,
          }}
        >
          Please wait while we set up your personalized creative workspace
        </Typography>
      </Box>
    </Container>
  );
};

export default AuthLoader;